/**
 * Consolidated icon image paths for all frontend pages.
 */

/**
 * Token icon mappings
 */
export const TOKEN_ICON_IMAGES: Record<string, string> = {
  uo: '/brand/assets/buy-uo.png',
  uo_sell: '/brand/assets/sell-uo.png',
  uo_total: '/brand/assets/uo-trading.png',
  ep: '/brand/assets/ep.png',
  ep1: '/brand/assets/ep-trading.png',
  ep2: '/brand/assets/exchange.png',
  sp1: '/brand/assets/staking.png',
  sp2: '/brand/assets/dex.png',
  sp3: '/brand/assets/dex.png',
  ap: '/brand/assets/auction.png',
  ap_queue: '/brand/assets/refresh.png',
  mp: '/brand/assets/hammer.png',
  uoc: '/brand/assets/orbc.png',
  rp: '/brand/assets/rp-mint.png',
  tp: '/brand/assets/transfer.png',
  fp: '/brand/assets/flower.png',
  fc: '/brand/assets/fuel.png',
  activation: '/brand/assets/hexagon.png',
  team_sum: '/brand/assets/chart.png',
  my_sum: '/brand/assets/home.png',
} as const;

/**
 * Navigation menu icons
 */
export const UI_ICONS = {
  home: '/icons/home.png',
  wallet: '/icons/wallet.png',
  hexagon: '/icons/hexagon.png',
  hammer: '/icons/hammer.png',
  person: '/icons/person.png',
  chart: '/icons/chart.png',
  flower: '/icons/flower.png',
  lock: '/icons/lock.png',
  refresh: '/icons/refresh.png',
  chat: '/icons/chat.png',
  globe: '/icons/globe.png',
  fuel: '/icons/fuel.png',
} as const;

/**
 * Wallet feature icons
 */
export const WALLET_FEATURE_ICONS = {
  uoTrading: '/brand/icons/uo-trading.png',
  epTrading: '/brand/icons/ep-trading.png',
  sellUo: '/brand/icons/sell-uo.png',
  rpMint: '/brand/icons/rp-mint.png',
  uodex: '/brand/icons/uodex.png',
  staking: '/brand/icons/staking.png',
  auction: '/brand/icons/auction.png',
  fuel: '/brand/icons/fuel.png',
} as const;

/**
 * EP Hub icons
 */
export const EP_HUB_ICONS = {
  ep1: '/brand/ep-hub/ep-1.png',
  ep2: '/brand/ep-hub/ep-2.png',
  status: '/brand/ep-hub/status.png',
  ep1Trading: '/brand/ep-hub/ep-1-trading.png',
  ep1Buy: '/brand/ep-hub/ep-1-buy.png',
  ep1Record: '/brand/ep-hub/ep-1-record.png',
} as const;

/**
 * Ecosystem project icons
 */
export const ECOSYSTEM_ICONS = {
  exchange: '/brand/ecosystem-icons/exchange.png',
  p2p: '/brand/ecosystem-icons/p2p.png',
  dex: '/brand/ecosystem-icons/dex.png',
  ep: '/brand/ecosystem-icons/ep.png',
  otc: '/brand/ecosystem-icons/otc.png',
  rpcoin: '/brand/ecosystem-icons/rpcoin.png',
  orbc: '/brand/ecosystem-icons/orbc.png',
  auction: '/brand/ecosystem-icons/auction.png',
  lock: '/brand/ecosystem-icons/lock.png',
  calculate: '/brand/ecosystem-icons/calculate.png',
} as const;

/**
 * Me section icons
 */
export const ME_ICONS = {
  candlestick: '/brand/me/candlestick.svg',
  horizontalDownRight: '/brand/me/horizontal_down_right.svg',
  horizontalDownLeft: '/brand/me/horizontal_down_left.svg',
  horizontalSwitch: '/brand/me/horizontal_switch.svg',
  return: '/brand/me/return.svg',
  groupShare: '/brand/me/group_share.svg',
  lineOut: '/brand/me/line_out.svg',
} as const;

/**
 * Wallet provider icons
 */
export const WALLET_PROVIDER_ICONS = {
  trust: '/brand/icons/wallets/trust-wallet.svg',
  metamask: '/brand/icons/wallets/metamask.svg',
  walletconnect: '/brand/icons/wallets/walletconnect.svg',
} as const;
